__turbopack_context__.v({
  "pickup-info": "g9GiCa_pickup-info",
});
